import PropTypes from 'prop-types';

export const propTypes = {
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    icon: PropTypes.node,
    text: PropTypes.string,
    pillActiveColor: PropTypes.string,
};
